import React from 'react'
import { textarea_class, label_class } from '../../functions/stateList'

export default function TextAreaInput({ title, name, value, inputHandler, error }) {
  return (
    <label htmlFor={name} className={label_class}>
      {title}
      <textarea
        id={name}
        name={name}
        rows="4"
        value={value}
        onChange={inputHandler}
        className={textarea_class}
        placeholder={`لطفا ${title} را وارد کنید`}
      ></textarea>
      {error?.[name] && <p className={'text-rose-500'}>{error?.[name]}</p>}
    </label>
  )
}
